import React from 'react'
import { Button, Image, connectToLocale } from '@insight/toolkit-react'
import { t } from '@insight/toolkit-utils/lib/labels'
import isMobile from '@insight/toolkit-utils/lib/media/isMobile'

export const SearchContentTile = ({ doc, query, index, isSolutionsServicesTab, context = {} }) => {
  const { imageUrl, pagePath, title } = doc
  const contentRediect = () => {
    const searchInfo = {
      searchKeyword: query,
      article_link_clicked: title,
      linkPositionClicked: index + 1,
    }
    window.fireTagEvent('searchInfo', searchInfo)

    window._satellite && _satellite.track && _satellite.track('searchInfo')

    window.location.href = pagePath
  }
  
  const mobileView = isMobile();
  const { isLoggedIn, isIPSUser } = context || {}
  const isLogoutIPSUser = !isLoggedIn && isIPSUser;
  const logoutIPSonMobile = isLogoutIPSUser && mobileView;
  if (logoutIPSonMobile) return null;

  return pagePath && title && !isSolutionsServicesTab ? (
    <div className="c-content-tile">
      <Button
        className="c-content-tile__image"
        color="inline-link"
        title={title}
        onClick={() => contentRediect()}
      >
        <Image image={imageUrl} alt={t(title || 'Product Image')} />
        <div className="c-content-tile__text">{title}</div>
      </Button>
    </div>
  ) : null
}

export default connectToLocale(SearchContentTile)
